import { InfoList } from "react-migration/components/InfoList";
import { FC, useId } from "react";

interface PropertyInfoItemProps {
  className?: string;
  title: string;
  testId?: string;
  children: React.ReactNode;
}

/**
 * Renders a label-value row. The value div has aria-labelledby pointing to the title
 * so it can be found with getByLabelText(title) in tests.
 */
export const PropertyInfoItem: FC<PropertyInfoItemProps> = ({ className, title, testId, children }) => {
  const id = useId();
  return (
    <InfoList.Item data-testid={testId} className={className}>
      <InfoList.ItemTitle id={id}>{title}</InfoList.ItemTitle>
      <InfoList.ItemValue aria-labelledby={id}>{children}</InfoList.ItemValue>
    </InfoList.Item>
  );
};
